<template>
  <div class="reserve">
    <div class="reserve-form">
      <div class="menu">
        <div
          class="item item1"
          @click="openUser()"
        >{{ searchForm.dingding_sumbit_user ? searchForm.dingding_sumbit_user : '工单/预约/推荐人' }}<van-icon name="arrow-down" /></div>
        <div
          class="item"
          @click="openChannel()"
        >{{ searchForm.channel_name ? searchForm.channel_name : '渠道名称' }}<van-icon name="arrow-down" /></div>
        <div
          class="item"
          @click="openFamilyDoctor()"
        >{{ searchForm.patient_name ? searchForm.patient_name : '客户姓名' }}<van-icon name="arrow-down" /></div>
      </div>
      <div class="date-label">
        <div
          class="label"
          v-for="(date, i) in dateList"
          :class="{'active': activeDateIndex === date.label}"
          :key="i"
          @click="changeDate(date, i)"
        >{{ date.label }}</div>
      </div>
      <van-form v-if="activeDateIndex === '选择日期'">
        <van-field
          readonly
          clickable
          name="datetimePicker"
          :value="searchForm.dateString"
          right-icon="arrow"
          label="自定义日期"
          placeholder="点击选择最近时间"
          @click="dateShow = true"
        />
        <van-calendar
          v-model="dateShow"
          color="#e7635e"
          :min-date="new Date('2024-06-01')"
          :default-date="searchForm.date"
          :allow-same-day="true"
          @confirm="onDateConfirm"
          type="range"
        />
      </van-form>
    </div>
    <div class="total" :class="{ 'expanded': isExpanded }">
      <div class="total-left">汇总：</div>
      <div class="total-right" v-html="resultTitle"></div>
      <div class="expanded-icon" @click="toggleText">
        <img src="@/assets/images/zk.svg" v-if="!isExpanded"/>
        <img src="@/assets/images/sq.svg" v-else/>
      </div>
    </div>
    <div class="reserve-export">
      <el-button
        type="primary"
        size="small"
        :loading="expLoading"
        round
        @click="exportExcel"
      >导出</el-button>
    </div>
    <div class="reserve-table">
      <el-table
        ref="tableRef"
        :data="tableData"
        v-loading="isLoading"
        height="100%"
        border
        size="small"
        row-key="id"
      >
        <el-table-column
          prop="arrival_time"
          label="到诊日期"
          width="100px"
        ></el-table-column>
        <el-table-column
          prop="hospital_area_project_name"
          label="预约项目"
        ></el-table-column>
        <el-table-column
          prop="dingding_sumbit_user"
          label="工单/预约/推荐人"
        ></el-table-column>
        <el-table-column
          prop="patient_name"
          label="客户姓名"
        ></el-table-column>
        <el-table-column
          prop="channel_name"
          label="渠道名称"
        ></el-table-column>
        <el-table-column
          prop="family_dr_name__c"
          label="家医"
        ></el-table-column>
      </el-table>

    </div>
    <CheckPicker
      :show="showTypePicker"
      :value="checkAll"
      :type="showType"
      :columns="columns"
      @confirm="confirmPicker"
      @cancel="cancelPicker"
      @search="searchPicker"
    />
  </div>
</template>

<script>
import moment from "moment";
// import { Toast } from "vant";
import reportService from "@/apis/reserve/index.js";
// import * as dd from "dingtalk-jsapi";
import CheckPicker from "@/components/CheckPicker/index.vue";
import { getFileNameFromDisposition } from "@/utils/utils";

export default {
  name: "ReserveAddWx",
  components: {
    CheckPicker,
  },

  data() {
    return {
      checkAll: [],
      // 自定义时间
      dateShow: false,
      activeDateIndex: "近7天",
      dateList: [
        {
          label: "选择日期",
          date: [],
        },
        {
          label: "近7天",
          date: [
            moment().subtract(6, "days").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ],
        },
        // {
        //   label: "近10天",
        //   date: [
        //     moment().subtract(9, "days").format("YYYY-MM-DD"),
        //     moment().format("YYYY-MM-DD"),
        //   ],
        // },
        {
          label: "近1个月",
          date: [
            moment().subtract(1, "months").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ],
        },
        {
          label: "近3个月",
          date: [
            moment().subtract(3, "months").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ],
        },
        {
          label: "近6个月",
          date: [
            moment().subtract(6, "months").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ],
        },
        {
          label: "近12个月",
          date: [
            moment().subtract(12, "months").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ],
        },
      ],
      // 员工 / 渠道
      showType: "",
      showTypePicker: false,
      columns: [],
      accountName: "",
      name: "",
      // 搜索条件
      searchForm: {
        dingding_sumbit_user: "",
        channel_name: "",
        patient_name: "",
        patientId: "",
        dateString: "",
        date: [
          moment().subtract(6, "days").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ],
      },
      // pageSize: 1,
      // pageNumber: 10,
      isExpanded: false,
      // 表格
      isLoading: false, // 是否正在加载
      // hasMore: true, // 是否还有更多数据
      tableData: [],
      resultTitle: "",
      expLoading: false
    };
  },
  watch: {
    searchForm: {
      handler(newVal) {
        this.searchForm.dateString = `${moment(newVal.date[0]).format(
          "YYYY-MM-DD"
        )}至${moment(newVal.date[1]).format("YYYY-MM-DD")}`;
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // 获取 el-table 的 DOM 元素
    // const table = this.$refs.tableRef.$el.querySelector('.el-table__body-wrapper');
    // // 监听 el-table 的滚动事件
    // table.addEventListener('scroll', this.handleScroll);
    // 初始化加载第一页数据
    this.getList();
  },
  // beforeDestroy() {
  //   // 获取 el-table 的 DOM 元素
  //   const table = this.$refs.tableRef.$el.querySelector('.el-table__body-wrapper');
  //   // 移除 el-table 的滚动事件监听，避免内存泄漏
  //   table.removeEventListener('scroll', this.handleScroll);
  // },
  methods: {
    exportExcel() {
      // if (dd.env.platform !== "notInDingTalk") {
      //   Toast("请在系统自带浏览器中打开页面导出EXCEL");
      //   return;
      // }
      this.expLoading = true
      reportService.exportChannelExcel({
        sign_time_start: moment(this.searchForm.date[0]).format("YYYY-MM-DD"),
        sign_time_end: moment(this.searchForm.date[1]).format("YYYY-MM-DD"),
        dateRange: this.activeDateIndex === "选择日期" ? true : false,
        prefixTitle: this.activeDateIndex === "选择日期" ? this.searchForm.dateString : this.activeDateIndex,
        ...this.searchForm,
      }).then(async (res) => {
        this.expLoading = false
        const contentDisposition = res.headers['content-disposition'];
        const filename = await getFileNameFromDisposition(contentDisposition);
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${filename}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      });
    },
    toggleText() {
      this.isExpanded =!this.isExpanded;
    },
    openUser() {
      this.checkAll = this.searchForm.dingding_sumbit_user
        ? this.searchForm.dingding_sumbit_user.split(",")
        : [];
      this.name = "";
      this.columns = [];
      this.getUserList();
      this.showType = "user";
      this.showTypePicker = true;
    },
    openFamilyDoctor() {
      this.checkAll = [];
      this.accountName = "";
      this.columns = [];
      // this.getDingUserList();
      this.showType = "client";
      this.showTypePicker = true;
    },
    openChannel() {
      this.checkAll = this.searchForm.channel_name
        ? this.searchForm.channel_name.split(",")
        : [];
      this.accountName = "";
      this.columns = [];
      this.getChannelList();
      this.showType = "channelName";
      this.showTypePicker = true;
    },
    confirmPicker(value) {
      let list = this.columns.filter(i => value.includes(i.id));
      let name
      switch (this.showType) {
        case "user":
          this.searchForm.dingding_sumbit_user = value.join(",");
          break;
        case "client":
          name = list.map(i => i.accountName);
          this.searchForm.patientId = value;
          this.searchForm.patient_name = name.join(",");
          break;
        case "channelName":
          this.searchForm.channel_name = value.join(",");
          break;
        default:
          break;
      }
      this.showTypePicker = false;
      this.getList();
    },
    cancelPicker() {
      this.showTypePicker = false;
    },
    searchPicker(val) {
      switch (this.showType) {
        case "user":
          this.name = val;
          this.getUserList();
          break;
        case "client":
          this.accountName = val;
          this.getDingUserList();
          break;
        case "channelName":
          this.accountName = val;
          this.getChannelList();
          break;
        default:
          break;
      }
    },
    changeDate(item, i) {
      this.activeDateIndex = item.label;
      if (i === 0) {
        this.searchForm.date = [];
      } else {
        this.searchForm.date = item.date;
      }
      this.getList();
    },
    onDateConfirm(date) {
      this.searchForm.date = date;
      this.dateShow = false;
      this.getList();
    },
    // handleScroll() {
    //   // 获取 el-table 的滚动容器
    //   const table = this.$refs.tableRef.$el.querySelector('.el-table__body-wrapper');
    //   // 滚动条距离顶部的距离
    //   const scrollTop = table.scrollTop;
    //   // 滚动容器的高度
    //   const clientHeight = table.clientHeight;
    //   // 滚动内容的总高度
    //   const scrollHeight = table.scrollHeight;
    //   // 判断是否滚动到接近底部
    //   if (scrollTop + clientHeight >= scrollHeight &&!this.isLoading && this.hasMore) {
    //     this.pageSize++; // 增加页码
    //     // this.getList();
    //   }
    // },
    getList() {
      const { searchForm } = this;
      const params = {
        sign_time_start: moment(searchForm.date[0]).format("YYYY-MM-DD"),
        sign_time_end: moment(searchForm.date[1]).format("YYYY-MM-DD"),
        dateRange: this.activeDateIndex === "选择日期" ? true : false,
        prefixTitle: this.activeDateIndex === "选择日期" ? this.searchForm.dateString : this.activeDateIndex,
        ...searchForm,
      };
      this.isLoading = true;
      reportService
        .getChannelLabelListApi(params)
        .then((res) => {
          this.tableData = res.data.result;
          // res.data.resultTitle = 共添加客户企微 65人，完成建档及完善信息人数 7 人，加微建档率为 10.8%， 曹洛青3人、石怡5人、SH圆和新永小助手 龚麦玲4人、Sara 🌱2人、廖伟武1人、叶菲1人、王琳1人、陈凯华4人、新太门诊部客服3人、圆圆22人、陈颖7人、林子榆6人、阎俊6人
          // 拼接时间
          let timeStr =
            this.activeDateIndex === this.dateList[0].label
              ? `${moment(searchForm.date[0]).format("YYYY-MM-DD")}至${moment(
                  searchForm.date[1]
                ).format("YYYY-MM-DD")}`
              : this.activeDateIndex;
          this.resultTitle = `${timeStr}，${res.data.resultTitle}`;
          // if (res.data.length > 0) {
          //   // 将新数据添加到现有数据中
          //   this.tableData = this.tableData.concat(res.data);
          // } else {
          //   // 没有更多数据了
          //   this.hasMore = false;
          // }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getChannelList() {
      reportService
        .getChannelListApi(
          {
            accountName: this.accountName,
          }
        )
        .then((res) => {
          this.columns = res.data;
        });
    },
    getUserList() {
      reportService
        .getUserListApi(
          {
            name: this.name,
          }
        )
        .then((res) => {
          this.columns = res.data;
        });
    },
    getDingUserList() {
      reportService
        .getDingUserListApi(
          {
            accountName: this.accountName,
          }
        )
        .then((res) => {
          this.columns = res.data;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.reserve {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .reserve-form {
    .menu {
      display: flex;
      align-items: center;
      gap: 10px;
      border-bottom: 1px solid #e3e3e3;
      .item {
        padding: 10px 0;
        width: 30%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 14px;
        text-align: center;
        border-right: 1px solid #e3e3e3;
        &:last-child {
          border-right: none;
        }
      }
      .item1 {
        width: 40%;
      }
    }
  }
  .date-label {
    padding: 10px 0;
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
    .label {
      padding: 6px;
      border-radius: 20px;
      border: 1px solid #ccc;
      font-size: 14px;
      display: inline-block;
      margin-right: 10px;
    }
    .active {
      color: #e7635e;
      border-color: #e7635e;
    }
  }
  .total {
    padding: 10px;
    font-size: 14px;
    display: flex;
    height: 45px;
    // overflow: hidden;
    position: relative;
    .color-red {
      color: #e7635e;
    }
    .total-left {
      flex: -1 1 40px;
    }
    .total-right {
      line-height: 22px;
      flex: 1;
    }
    .expanded-icon {
      position: absolute;
      z-index: 10;
      right: 0;
      bottom: -10px;
      background-color: rgb(238, 241, 249);
      // width: 40px;
      // text-align: center;
      img {
        width: 36px;
        height: 24px;
      }
    }
  }
  .expanded {
    height: auto;
  }
  .el-button {
    width: 100%;
    background-color: #e7635e;
    border: none;
  }
  .reserve-title {
    margin-bottom: 10px;
    color: #e7635e;
    min-height: 40px;
  }
  .reserve-export {
    position: relative;
    z-index: 9;
    background-color: rgb(238, 241, 249);
    padding: 20px 10px 10px;
  }
  .reserve-table {
    position: relative;
    z-index: 9;
    height: 100%;
    padding-bottom: 20px;
    overflow: hidden;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
  .el-date-editor.el-input__inner {
    width: 220px;
  }
}
</style>